import { useIsInternalEmployee } from '~/common/hooks/useIsInternalEmployee';
import { useAppContext } from '~/services/main/contexts/AppContext';

interface OrganizationDemoAccess {
  canViewOrganizationDemo: boolean;
  isCheckingAccess: boolean;
  isDemoEnvironment: boolean;
  isInternalEmployee: boolean;
}

export const useCanViewOrganizationDemo = (): OrganizationDemoAccess => {
  const {
    selectedOrganization,
    isSelectedOrgAdmin,
    loadingOrganizations,
    loadingIsSelectedOrgAdmin,
  } = useAppContext();

  const isInternalEmployee = useIsInternalEmployee();
  const isDemoEnvironment = window.ENVS.environment !== 'production';
  const isCheckingAccess = loadingOrganizations || loadingIsSelectedOrgAdmin;
  const canViewOrganizationDemo = Boolean(
    isDemoEnvironment &&
      selectedOrganization &&
      isSelectedOrgAdmin &&
      isInternalEmployee
  );

  return {
    canViewOrganizationDemo,
    isCheckingAccess,
    isDemoEnvironment,
    isInternalEmployee,
  };
};
